import React from 'react';
import MLink from '@mui/material/Link';
import CircularProgress from '@mui/material/CircularProgress';
import LoadingButton from '@mui/lab/LoadingButton';
import SaveIcon from '@mui/icons-material/Save';
import Button from '@mui/material/Button';
import { useHistory } from 'react-router';

interface IProps {
  disabled?: boolean;
  to?: string;
  text: string | JSX.Element;
  onClick?: () => void | Promise<void>;
  confirmMessage?: string;
  isAsync?: boolean;
  button?: boolean;
  color?: 'primary' | 'error';
}

export default function Link(props: IProps) {
  const history = useHistory();
  const [loading, setLoading] = React.useState(false);
  const { to, text, onClick, confirmMessage, button, isAsync, color, disabled } = props;

  const handleClick = async () => {
    if (disabled) {
      return;
    }
    if (confirmMessage) {
      const agreed = confirm(confirmMessage);
      if (!agreed) {
        return;
      }
    }
    if (to) {
      history.push(to);
    } else if (onClick) {
      if (isAsync) {
        setLoading(true);
        await onClick();
        setLoading(false);
      } else {
        onClick();
      }
    }
  };

  if (button) {
    if (loading) {
      return (
        <LoadingButton loading loadingPosition="start" startIcon={<SaveIcon />} variant="outlined">
          {text}
        </LoadingButton>
      );
    }

    return (
      <Button
        disabled={disabled}
        onClick={handleClick}
        variant="contained"
        color={color || 'primary'}
      >
        {text}
      </Button>
    );
  } else {
    if (loading) {
      return <CircularProgress size={20} />;
    }

    return <MLink onClick={handleClick}>{text}</MLink>;
  }
}
